import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles/CartPriceRow.scss';

const CartPriceRow = props => {
    const { label, children, hasTopLine, isStrikeOut } = props;

    const rowClass = classNames(styles.row, {
        [styles.topLine]: hasTopLine,
    });

    return (
        <div className={rowClass}>
            <div className={styles.priceLabel}>{label}</div>
            <div className={isStrikeOut ? styles.priceStrike : ''} data-tn="item-price">
                {children}
            </div>
        </div>
    );
};

CartPriceRow.propTypes = {
    label: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired,
    hasTopLine: PropTypes.bool,
    isStrikeOut: PropTypes.bool,
};

export default CartPriceRow;
